export default "__VITE_ASSET__DbNe5tjs__"